var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defaultLayoutContainer wrapper appWrapper"},[_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[(_vm.loading)?_c('c-loading-screen'):_c('router-view',{staticClass:"viewContainer",attrs:{"id":"routerViewport"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }